__turbopack_context__.v({
  "p": "stilling-module__-W33nq__p",
  "styledCardItem": "stilling-module__-W33nq__styledCardItem",
});
